import { visuallyHidden } from '@mui/utils';
export var mixins = {
  focusRing: function focusRing(props) {
    var _props$color;

    if (props === void 0) {
      props = {};
    }

    return {
      outline: "1px solid " + ((_props$color = props.color) != null ? _props$color : 'currentColor'),
      outlineOffset: '1px'
    };
  },
  placeholder: {
    fontStyle: 'italic',
    opacity: 0.5
  },
  visuallyHidden: visuallyHidden
};